import { render, staticRenderFns } from "./setStudentStatus.vue?vue&type=template&id=95ad566e&"
import script from "./setStudentStatus.vue?vue&type=script&lang=js&"
export * from "./setStudentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports